import React, { useState, useEffect } from 'react';
import { apiFetch } from "../../../apiFetch";
import { useNavigate } from 'react-router-dom';
import './Profile.css';

const Profile = ({ onProfileImageChange, userId }) => {
  const [profileImage, setProfileImage] = useState(null);
  const [profileSlugState, setProfileSlugState] = useState(null);
  const navigate = useNavigate();
  const inputId = `file-input-${userId}`;

  // Fetch existing profile image + profile slug from backend
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await apiFetch(`/api/player-details/${userId}`);

        if (!res.ok) {
          const text = await res.text().catch(() => "");
          throw new Error(`Failed to fetch profile (${res.status}): ${text}`);
        }

        const data = await res.json();

        console.log("Profile image URL:", data.profileImageUrl);

        if (data.profileImageUrl) {
          setProfileImage(data.profileImageUrl);
          onProfileImageChange?.(data.profileImageUrl);
        } else {
          setProfileImage(null);
          onProfileImageChange?.(null);
        }

        if (data.profileSlug) {
          setProfileSlugState(data.profileSlug);
        }
      } catch (err) {
        console.error('Error fetching player image:', err);
        setProfileImage(null);
        onProfileImageChange?.(null);
      }
    };

    if (userId) fetchProfile();
  }, [userId, onProfileImageChange]);

  // Upload image to backend
  const handleImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !userId) return;

    const formData = new FormData();
    formData.append('image', file);
    formData.append('userId', userId);

    try {
      const res = await apiFetch("/api/upload-profile-image", {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(`Upload failed (${res.status}): ${text}`);
      }

      const data = await res.json();

      if (data.imageUrl) {
        const freshImageUrl = `${data.imageUrl}?t=${Date.now()}`;
        setProfileImage(freshImageUrl);

        if (onProfileImageChange) {
          onProfileImageChange(freshImageUrl);
        }
      } else {
        alert('Upload failed');
      }
    } catch (err) {
      console.error("Upload error:", err);
      alert(err.message || "Upload failed");
    }
  };

  // View public player profile
  const handleViewProfile = () => {
    if (!profileSlugState) {
      alert('Profile is not yet public.');
      return;
    }

    navigate(`/player-profile/${profileSlugState}`);
  };

  return (
    <div className="player-dashboard-profile-section">
      <div className="profile-photo">
        {profileImage ? (
          <img
            src={profileImage}
            alt="Profile"
            className="profile-image"
            onError={() => {
              console.error("Failed to load profile image:", profileImage);
              setProfileImage(null);
              onProfileImageChange?.(null);
            }}
          />
        ) : (
          <span className="default-profile"></span>
        )}

        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          className="file-input"
          id={inputId}
        />

        <label
          htmlFor={inputId}
          className="camera-icon"
          aria-label="Upload profile photo"
        >
          {/* Corrected SVG camera icon (full, centered, yellow) */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="22"
            height="22"
            fill="yellow"
            style={{ display: 'block' }}
          >
            <path d="M9 2h6l1.83 2H19a3 3 0 013 3v9a3 3 0 01-3 3H5a3 3 0 01-3-3V7a3 3 0 013-3h2L9 2zm3 6a4 4 0 100 8 4 4 0 000-8z" />
          </svg>
        </label>
      </div>

      <button
        className="view-profile-button"
        onClick={handleViewProfile}
        disabled={!profileSlugState}
      >
        View Profile
      </button>
    </div>
  );
};

export default Profile;









